export enum States {
  Alaska = 'AK',
  Alabama = 'AL',
  Arkansas = 'AR',
  Arizona = 'AZ',
  California = 'CA',
  Colorado = 'CO',
  Connecticut = 'CT',
  District_of_Columbia = 'DC',
  Delaware = 'DE',
  Florida = 'FL',
  Georgia = 'GA',
  Hawaii = 'HI',
  Iowa = 'IA',
  Idaho = 'ID',
  Illinois = 'IL',
  Indiana = 'IN',
  Kansas = 'KS',
  Kentucky = 'KY',
  Louisiana = 'LA',
  Massachusetts = 'MA',
  Maryland = 'MD',
  Maine = 'ME',
  Michigan = 'MI',
  Minnesota = 'MN',
  Missouri = 'MO',
  Mississippi = 'MS',
  Montana = 'MT',
  North_Carolina = 'NC',
  North_Dakota = 'ND',
  Nebraska = 'NE',
  New_Hampshire = 'NH',
  New_Jersey = 'NJ',
  New_Mexico = 'NM',
  Nevada = 'NV',
  New_York = 'NY',
  Ohio = 'OH',
  Oklahoma = 'OK',
  Oregon = 'OR',
  Pennsylvania = 'PA',
  Rhode_Island = 'RI',
  South_Carolina = 'SC',
  South_Dakota = 'SD',
  Tennessee = 'TN',
  Texas = 'TX',
  Utah = 'UT',
  Virginia = 'VA',
  Vermont = 'VT',
  Washington = 'WA',
  Wisconsin = 'WI',
  West_Virginia = 'WV',
  Wyoming = 'WY',
}
